import { ModalConfirmation } from "./Confirmation";
import { AssignEmployeesProjects } from "./AssignEmployeesProjects";

const ModalRegistry = {
  'confirmation': ModalConfirmation,
  'assignEmployeesProjects': AssignEmployeesProjects
}

export default ModalRegistry;
